import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Resource/components/Card';
import FormContainer from './components/FormContainer';

class Summary extends React.Component {
  convertTimeStringToMinutes = (timeString) => {
    const a = timeString.split(':'); // split it at the colons

    // Hours are worth 60 minutes.
    const minutes = (+a[0]) * 60 + (+a[1]);

    return minutes;
  };

  validateVoucher = (voucher) => {
    const bookingData = this.props.bookingData;

    const findIndex = bookingData.findIndex(({ id }) => id === voucher.resource);

    if (findIndex === -1) {
      return false;
    }

    if (findIndex !== -1) {
      // bookingData[findIndex]
      /*
      {
  "discount": "100.00",
  "percent": false,
  "per_participant": true,
  "code": 1231231239,
  "resource": "5qxzx61v8e8wa57qNwNw",
  "valid_ranges": null,
  "valid_products": [
    10,
    15
  ],
  "description": "100 kr rabatt per person"
}
       */

      const { productCost, product } = bookingData[findIndex];
      const { participants } = bookingData[findIndex];

      if (voucher.valid_ranges !== null) {
        // if its locked to a special day check if its available

        const d = new Date(bookingData[findIndex].date.date);
        const n = d.getDay();

        const findIndexForRange = voucher.valid_ranges.findIndex(({ day }) => day === n);

        // alert(findIndexForRange);

        if (findIndexForRange === -1) {
          // The chosen day is not in the valid range
          return false;
        }

        if (findIndexForRange !== -1) {
          const range = voucher.valid_ranges[findIndexForRange];


          const RangeStart = this.convertTimeStringToMinutes(range.start);
          const RangeEnd = this.convertTimeStringToMinutes(range.end);

          const chosenStart = this.convertTimeStringToMinutes(bookingData[findIndex].date.start);
          const chosenEnd = this.convertTimeStringToMinutes(bookingData[findIndex].date.end);


          if (chosenStart >= RangeStart &&
            chosenEnd <= RangeEnd) {
            // console.log('Min valda tid är inom den definierade rangen');
          } else {
            return false;
          }
        }
      }

      if (voucher.valid_products !== null) {
        // Det finns produkter att kontrollera mot

        const found = voucher.valid_products.find(element => element === product);

        if (found === undefined) {
          // Vald produkt finns inte, därför blir det ingen rabatt
          return false;
        }

      }

      if (voucher.min_participants !== null) {
        // Det finns ett angivet minsta antal deltagare som kupongen måste ta hänsyn till

        if (participants < voucher.min_participants) {
          return false;
        }
      }

      let voucherAmount;


      if (voucher.percent) {
        voucherAmount = (productCost / 100) * voucher.discount;
      } else {
        voucherAmount = voucher.discount;
      }


      if (voucher.per_participant) {
        voucherAmount *= participants;
      }
      return (Math.round(voucherAmount * 10 ) / 10);
    }
  }

  render() {
    const {
      bookingData, inputFields, voucher, hashId, lang, productSettings, bIKey
    } = this.props;

    const { sumProduct } = productSettings;

    let calculateTotal = 0;
    let voucherAmount = false;

    if (voucher !== undefined) {
      voucherAmount = this.validateVoucher(voucher);
    }

    return (
      <Card title={lang.topic}>
        <div className="col-sm-4">
          {bookingData &&
          bookingData
            .map(({
                    id, participants, date, productName, productCost, optionalProducts,
            }) => {
              calculateTotal = +calculateTotal + (+productCost * +participants);
              return (
                <div key={id} className="alert alert-info">
                  <strong>{productName}</strong> <br />

                  {participants > 1 ? (
                    <React.Fragment>
                      <strong>{participants}</strong> {lang.participants}. <br />
                    </React.Fragment>
                    ) : null}


                  <strong>{date.date}</strong> {lang.timePresentation} {date.start} - {date.end} <br />
                  <strong>{productCost * participants} {lang.currency}</strong>
                  {optionalProducts !== undefined && optionalProducts.length > 0 && (
                    <React.Fragment>
                      <br />
                      <br />
                      <strong>Tillval:</strong>
                      <br />
                    </React.Fragment>
                  )}
                  {optionalProducts !== undefined && optionalProducts.length > 0 &&
                optionalProducts.map(({
 sku, name, perPerson, cost, percent,
}) => {
                  let showCost = cost;

                  if (percent) {
                    if (sumProduct) {
                      showCost = ((productCost * participants) / 100) * cost;
                    } else {
                      showCost = ((productCost) / 100) * cost;
                    }
                  }
                  if (perPerson === 'yes' && percent === false) {
                    showCost = (+cost * +participants);
                  }

                  calculateTotal = +calculateTotal + +showCost;


                  return (
                    <p>{name}: {showCost} SEK </p>
                  );
})}


                </div>
            );
})}

          {voucher && voucherAmount !== false && (
            <div key="voucher" className="alert alert-warning" >
              <strong>{voucher.description}</strong> <br />

              <strong>
                - {voucherAmount} {lang.currency}
              </strong>
            </div>
          )}

          {calculateTotal !== 0 && (
            <div key="summary" className="alert alert-success" >
              <strong>
                {lang.totalCost}: {calculateTotal - voucherAmount} {lang.currency}
              </strong>
            </div>

          )}
        </div>

        <div className="col-sm-8">
          <FormContainer
            hashId={hashId}
            lang={lang}
            voucher={voucher}
            inputFields={inputFields}
            bookingData={bookingData}
            bIKey={bIKey ? bIKey : null}
          />

        </div>
        {1 === 2 && (
          <div>
              <pre>{JSON.stringify(voucher, null, 2)}</pre>
            <pre>{JSON.stringify(bookingData, null, 2)}</pre>
          </div>
        )}

      </Card>

    );
  }
}
// Todo: PropTypes


Summary.propTypes = {
  hashId: PropTypes.string.isRequired,
  bookingData: PropTypes.arrayOf(PropTypes.shape({
    participants: PropTypes.number.isRequired,
    date: PropTypes.objectOf(PropTypes.shape({
      date: PropTypes.string.isRequired,
      start: PropTypes.string.isRequired,
      end: PropTypes.string.isRequired,
    })),
    product: PropTypes.number.isRequired,
  })).isRequired,
};

Summary.defaultProps = {
  bookingData: undefined,
};
export default Summary;



// WEBPACK FOOTER //
// ./src/components/Summary/index.jsx